import FallbackImage from './FallbackImage';

function PhotoModal({ photo, onClose }) {
  if (!photo) return null;

  return (
    <div className="photo-modal" role="dialog" aria-modal="true" aria-label={photo.title}>
      <button className="photo-modal-close" type="button" onClick={onClose}>
        Close
      </button>
      <div className="photo-modal-info">
        <b>{photo.placeName}</b>
        <span>{photo.title}</span>
        <small>
          {photo.latitude}, {photo.longitude}
        </small>
      </div>
      <FallbackImage
        src={photo.src}
        alt={photo.title}
        label={photo.placeName}
        className="photo-modal-image"
        aspect={photo.aspect}
      />
    </div>
  );
}

export default PhotoModal;
